import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { Notify } from 'quasar'
import { $t } from 'boot/common/i18n'

import { useTemplateStore } from 'stores/receiver/templates/templates'
import { useEventsStore } from 'stores/common/events'

const notification = ref()

export const useDuplicateTemplate = () => {
  const templateStore = useTemplateStore()
  const router = useRouter()

  const duplicateLoading = ref(false)

  const duplicateTemplate = async (templateId: string) => {
    duplicateLoading.value = true

    const success = await templateStore.duplicateTemplate(templateId)

    if (success) {
      notification.value = Notify.create({
        message: $t('receiver.templates.edit.duplicate.inProgress'),
        type: 'info',
      })

      await router.push('/templates')
    }

    duplicateLoading.value = false
  }

  const notifyEndOfDuplication = () => {
    const eventsStore = useEventsStore()

    watch(
      () => eventsStore.eventData,
      (val) => {
        if (val?.type === 'template_added') {
          if (notification.value) {
            notification.value()
          }

          notification.value = Notify.create({
            message: $t('receiver.templates.edit.duplicate.success'),
            type: 'positive',
          })
        }
      }
    )
  }

  const watchTemplateDuplicationEvent = (
    action: (templateId: string) => void
  ) => {
    const eventsStore = useEventsStore()

    watch(
      () => eventsStore.eventData,
      (val) => {
        if (val?.type === 'template_added') {
          action(val.context.template_id)
        }
      }
    )
  }

  return {
    duplicateTemplate,
    duplicateLoading,
    notifyEndOfDuplication,
    watchTemplateDuplicationEvent,
  }
}
